<script setup lang="ts"></script>

<template>
  <div class="absolute inset-x-0 bottom-0 flex items-center justify-end px-6 py-4 space-x-4">
    <slot></slot>
  </div>
</template>
